import { Controller } from "@hotwired/stimulus"
import Swiper from 'swiper/bundle';

export default class extends Controller {
  static targets = ["main", "thumbs"]

  connect() {
    // Initialize thumb swiper first
    this.thumbSwiper = new Swiper(this.thumbsTarget, {
      spaceBetween: 10,
      slidesPerView: 4,
      freeMode: true,
      watchSlidesProgress: true,
    });

    // Initialize main swiper with thumbs
    this.mainSwiper = new Swiper(this.mainTarget, {
      spaceBetween: 10,
      navigation: {
        nextEl: this.mainTarget.querySelector('.swiper-button-next'),
        prevEl: this.mainTarget.querySelector('.swiper-button-prev')
      },
      thumbs: {
        swiper: this.thumbSwiper
      }
    });

    // Make thumbs clickable
    this.thumbsTarget.querySelectorAll('.swiper-slide').forEach((slide, index) => {
      slide.style.cursor = 'pointer';
      slide.addEventListener('click', () => {
        this.mainSwiper.slideTo(index);
      });
    });
    console.log("GalleryCarouselController connected");
  }

  disconnect() {
    console.log("GalleryCarouselController disconnected");
    if (this.mainSwiper) {
      this.mainSwiper.destroy();
    }
    if (this.thumbSwiper) {
      this.thumbSwiper.destroy();
    }
  }
}
